import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import cn from "classnames";
import AddBoxOutlinedIcon from "../../../../../../../../icons/OpenTree";
import RemoveOutlinedIcon from "../../../../../../../../icons/CloseTree";
import { useStyles, useInputStyles } from "./TransferList.styles";
import { not, intersection } from "./TransferList.utils";
import { useTransferList } from "./TransferList.state";
import { Tree } from "./Tree";
import { Search } from "./Search";
import { Actions } from "./Actions";
import { IEStyles } from "./IEStyles";
import { GradientLoader } from "../../../../../../../common";
import type { ITransferListProps } from "./TransferList.types";

export const TransferList: React.FC<ITransferListProps> = (props) => {
  const classes = useStyles();
  const { onChange } = props;
  const { searchValue, hierarchies, candidateHierarchies, selectedHierarchies, selectedIds, onToggleItemHandler, onSearchHandler } =
    useTransferList(props);
  const expandedAll = Boolean(searchValue);
  const isCandidatesEmpty = Boolean(searchValue && candidateHierarchies.length === 0);
  const isSelectedEmpty = Boolean(searchValue && selectedHierarchies.length === 0);

  const content = (
    <>
      <IEStyles />
      <Search onChange={onSearchHandler} />
      <Grid container spacing={2} justifyContent="center" alignItems="center" className={classes.root}>
        <Grid item className={classes.box}>
          <Tree
            isEmpty={isCandidatesEmpty}
            expandedAll={expandedAll}
            hierarchies={candidateHierarchies}
            selected={selectedIds}
            onToggleItem={onToggleItemHandler}
          />
        </Grid>
        <Grid item className={cn(classes.buttons, "for-ie-buttons")}>
          <Grid container direction="column" alignItems="center">
            <Actions
              onChange={onChange}
              selectedIds={selectedIds}
              hierarchies={hierarchies}
              candidateHierarchies={candidateHierarchies}
              selectedHierarchies={selectedHierarchies}
            />
          </Grid>
        </Grid>
        <Grid item className={classes.box}>
          <Tree
            isEmpty={isSelectedEmpty}
            expandedAll={expandedAll}
            hierarchies={selectedHierarchies}
            selected={selectedIds}
            onToggleItem={onToggleItemHandler}
          />
        </Grid>
      </Grid>
    </>
  );

  const isLoaderOpen = hierarchies.length === 0 && !searchValue;

  return (
    <div className={classes.container}>
      <GradientLoader open={isLoaderOpen} width="893px" height="490px" variant="rect" />
      {isLoaderOpen ? null : content}
    </div>
  );
};
